// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"80efc53e","952":"ff9243c2"}[chunkId] + ".chunk.js";
};